/**
 * SOCKET CONST
 */

export default {
  IMAGE_GENERATED: 'message.generator',
};
